/* ==========================================================
   טבלת ההשוואה (product_comparison) – כרטיס ירוק כהה.
   משלים את assets/claude-comparison-dark.css:
   - מוסיף חלק עליון: הכותרת של הסקשן + תמונת המוצר של העמודה
     הראשונה בגודל גדול (מבקש גרסה ברזולוציה גבוהה מה-CDN).
   - שם עמודת המוצר ריק? מציג "SOURCE".
   - מחליף את אייקוני ה-V / X בעיגול ליים עם V ועיגול מתאר עם X.
   אידמפוטנטי; רץ שוב כשהסקשן נטען מחדש בעורך הערכה.
   ========================================================== */
(function () {
  'use strict';

  var NS = 'http://www.w3.org/2000/svg';

  function icon(paths, width) {
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('class', 'cd-icon');
    svg.setAttribute('aria-hidden', 'true');
    paths.forEach(function (d) {
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('fill', 'none');
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', width);
      p.setAttribute('stroke-linecap', 'round');
      p.setAttribute('stroke-linejoin', 'round');
      svg.appendChild(p);
    });
    return svg;
  }

  function bigger(src) {
    if (!src) return src;
    // Shopify CDN: גודל כסיומת בשם הקובץ (_150x.png) או כפרמטר width
    if (/_\d*x\d*\.(png|jpe?g|webp|gif)/i.test(src)) return src.replace(/_\d*x\d*\.(png|jpe?g|webp|gif)/i, '_800x.$1');
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&]width=)\d+/, '$1700');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=700';
  }

  function enhance(section) {
    var root = section.querySelector('.comparison-section');
    var column = section.querySelector('.comparison-table-column');
    if (!root || !column) return;
    root.classList.add('cmp-dark');

    if (!column.querySelector('.cd-top')) {
      var heading = section.querySelector('.comparison-heading');
      var img = section.querySelector('.column-1-img');
      var top = document.createElement('div');
      top.className = 'cd-top';

      var title = document.createElement('h2');
      title.className = 'cd-title';
      title.textContent = heading ? heading.textContent.trim() : '';
      top.appendChild(title);

      if (img) {
        var big = document.createElement('img');
        big.className = 'cd-img';
        big.alt = img.alt || '';
        big.loading = 'lazy';
        big.src = bigger(img.currentSrc || img.getAttribute('src'));
        top.appendChild(big);
      }
      column.insertBefore(top, column.firstChild);
    }

    var brand = section.querySelector('.product-header.column-1 .comparison-product-title');
    if (brand && !brand.textContent.trim()) brand.textContent = 'SOURCE';

    // צבע שהבלוק קובע inline (!important) גובר על העיצוב – מסירים אותו
    section.querySelectorAll('.feature-name, .comparison-product-title').forEach(function (el) {
      el.style.removeProperty('color');
    });

    section.querySelectorAll('.check-yes').forEach(function (el) {
      if (!el.querySelector('.cd-icon')) el.appendChild(icon(['M6 12.5l4 4 8-9'], '2.6'));
    });
    section.querySelectorAll('.check-no').forEach(function (el) {
      if (!el.querySelector('.cd-icon')) el.appendChild(icon(['M6 6l12 12', 'M18 6L6 18'], '2'));
    });
  }

  function run() {
    document.querySelectorAll('[id*="product_comparison"]').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  document.addEventListener('shopify:section:load', run);
})();
